import React, { Dispatch, SetStateAction } from "react";
import { AppThemes } from "../Constants";

// @author E42303 Judhjit Ganguli

export type UserPreferences = {
  id: number | undefined;
  theme: string;
  app_tour: string;
  tab_order: string;
  flashonchatmessage: boolean;
  enablepushnotifications: boolean;
  enablepushnotificationssound: boolean;
  defaultaccount: string;
  fontSize: string;
  tradinggridgroupsorder: string;
  aggregatedview: boolean;
  pnlview: boolean;
};

export type UserPreferencesContextType = {
  userPreferences: UserPreferences;
  setUserPreferences: Dispatch<SetStateAction<UserPreferences>>;
};

const defaultState = {
  userPreferences: {
    id: undefined,
    theme: AppThemes.DARK,
    app_tour: "",
    tab_order: "",
    flashonchatmessage: false,
    enablepushnotifications: false,
    enablepushnotificationssound: false,
    defaultaccount: "",
    fontSize: "MEDIUM",
    tradinggridgroupsorder: "",
    aggregatedview: false,
    pnlview: false,
  },
  setUserPreferences: (user: UserPreferences) => {},
} as UserPreferencesContextType;

export const UserPreferencesContext = React.createContext(defaultState);

export default UserPreferencesContext;
